const colors = {
  primaryColor: "#11adf3",
  primaryHover: "#0088a6",
  primaryInactiveColor: "#a5a8ad",
  disabledColor: "#e7ebed",
  tabDisabledColor: "#c4c7ca",
  textDisabledColor: "#c6c9cb",
  infoBorderColor: "#10adf3",
  white: "#ffffff",
  black: "#000000",
  borderColor: "#e7e8ea",
  primaryBorderColor: "#11adf3",
  starInactive: "#d4d4d4",
  starActive: "#ffd05b",
  greyBackground: "#fbfcfc",
  tagInactive: "#a7a9ad",
  tagActive: "#e9f7fd",
  contentText: "#354052",
  redText: "#f96d72",
  newTagInactive: "#eef0f0",
  newTagText: "#898c90",
  successColor: "#51d3b7",
  bgGrey: "#f8f9fa",
  textGreen: "#09c199",
}

export default colors
